import { render } from 'preact'
import { html } from 'htm/preact'
import { App } from './app.js'
import './style.css'

console.log('Main.js: Starting application...')

try {
  const appElement = document.getElementById('app')
  if (!appElement) {
    console.error('Main.js: Could not find #app element!')
  } else {
    console.log('Main.js: Found app element, rendering...')
    render(html`<${App} />`, appElement)
    console.log('Main.js: App rendered successfully!')
  }
} catch (error) {
  console.error('Main.js: Error rendering app:', error)
}